<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de Paciente">
            <rkm-layout-content>
                <List :item="item" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/exame-laboratorial/agendamento-exame-retroativo/List'

export default {
    components: { List },
    props: {
        item: { type: Object, default: null }
    },
}
</script>